import token, { tokenToVars } from '../token';
import Pagination from './pagination';

export { Pagination };
export default tokenToVars(Pagination, token);
